<template>
  <div class="brain-popover" v-if="showPopover">
    <div class="popover-mask"></div>
    <div class="popover-content">
      <div class="popover-head">
        <span class="popover-title">{{ $t("_data.add_to_pro") }}</span>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click.stop="closePopover"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="popover-body project-popover-body">
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
        >
          <el-form-item :label="$t('_data.project') + '：'" prop="project_id">
            <el-select v-model="formData.project_id" @change="selectProject">
              <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('project.group') + '：'" prop="group_id">
            <el-select v-model="formData.group_id">
              <el-option
                v-for="item in groups"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <div class="form-group row">
            <label for="subject_age" class="col-sm-3 col-form-label text-right">
              <span class="text-danger">*</span>
              {{ $t("project.group") }}:
            </label>
            <div class="col-sm-9">
              <el-select v-model="value" clearable placeholder="">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div> -->
        </el-form>
      </div>
      <div class="popover-footer text-right">
        <button
          type="button"
          class="btn btn-grey btn-sm ml10"
          @click.stop="closePopover"
        >
          {{ $t("cancel") }}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm ml10"
          @click.stop="submitAddToProject('ruleForm')"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showPopover: {
      type: Boolean,
      default: false,
    },
    projects: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    projects: function (val, oldVal) {
      console.log(val);
      console.log(oldVal);
      this.projects = val;
    },
  },
  data() {
    return {
      groups: [],
      formData: {
        project_id: "",
        group_id: "",
        userid: "", //project.user_id,后端字段：userid
      },
    };
  },
  computed: {
    rules() {
      return {
        project_id: [{ required: true, message: " ", trigger: "change" }],
        group_id: [{ required: true, message: " ", trigger: "change" }],
      };
    },
  },
  mounted() {},
  methods: {
    selectProject(value) {
      //console.log(value); value is model-v project.id
      this.groups = [];
      let project = this.projects.filter((item) => item.id === value);
      console.log(project[0]);
      this.groups = project[0].group;
      this.formData.userid = project[0].user_id;
    },
    submitAddToProject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("handleAddToProject", this.formData);
          this.groups = [];
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    closePopover() {
      this.$emit("closeAddPopover");
    },
  },
};
</script>

<style lang="less">
.brain-popover .project-popover-body {
  padding-right: 100px;
  .el-select {
    width: 100%;
  }
}
</style>
